import { render, staticRenderFns } from "./SubscriptionCtaPopup.vue?vue&type=template&id=0023642a&scoped=true&"
import script from "./SubscriptionCtaPopup.vue?vue&type=script&lang=js&"
export * from "./SubscriptionCtaPopup.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionCtaPopup.vue?vue&type=style&index=0&id=0023642a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0023642a",
  null
  
)

export default component.exports